(function($) {
    'use strict';

    var ModuleName = 'clp_gpby';

    var Module = function(element, options) {

        this.ele = element;
        this.$ele = $(element);

        this.option = options;
        this.$maxH;
        this.btnEle;
        this.$clp_btn;
        this.$clp_btntext;
        this.opHtml;
        this.clsHtml;

    };

    Module.DEFAULT = {
        btnSettings:{ closeHtml:null, openHtml:null },
        open:false,
        whenClosed: function ($this) { /* console.log("closed"); */ }
    };

    Module.prototype.setClick = function(){
        
        this.$clp_btn.on('click', function() {

            this.$ele.toggleClass('open');

            if(this.$clp_btntext.html() == this.clsHtml){
                if(this.opHtml == null){
                    this.$clp_btntext.html(this.clsHtml);
                }else{
                    this.$clp_btntext.html(this.opHtml); 
                }
            }else{
                this.$clp_btntext.html(this.clsHtml); 
            }
            if (!this.$ele.hasClass("open")) { (this.option.whenClosed && typeof this.option.whenClosed == "function") && this.option.whenClosed(this.$ele); }
                
        }.bind(this));

    }

    Module.prototype.setResize = function(){

        $(window).on('resize', function(){

            var currentHeight = this.$ele.children('.high').outerHeight();
            var maxHeight = parseInt(this.$ele.children('.high').css('max-height')) || 0;

            if( currentHeight >= maxHeight ){
                this.$ele.addClass('active');
                this.$clp_btn.css('display','inline-block');
            } else {
                this.$ele.removeClass('active');
                this.$clp_btn.hide();
            }

            // if( window.innerWidth < 980 ){
            //     $('.m-appear').removeClass('clear');
            //     $('.pc-none').removeClass('clear');
            //     $('.m-none').addClass('clear');
            // }else{
            //     $('.m-appear').addClass('clear');
            //     $('.pc-none').addClass('clear');
            //     $('.m-none').removeClass('clear');
            // }

        }.bind(this));

        $(window).trigger('resize');

    }

    Module.prototype.clickDelete = function() {
        var $delete = this.$ele.find('.filter_btn>.delete');
        var _self = this,
            $self = this.$ele;
        $delete.on('click',function(){
            if (!!_self.option.whenClickDelete && typeof _self.option.whenClickDelete == "function") _self.option.whenClickDelete($(this),$self)
        });
    }


    Module.prototype.init = function() {

        // add Class到this.$ele.
        this.$ele.addClass(ModuleName);

        // init $maxH.
        this.$maxH = this.option.maxHeight;

        // 如果html上沒有.clp_btn, 則生成一個.
        if( this.$ele.children('.clp_btn').length == 0 ){
            if (this.option.mode === 'filter') {
                console.log('filter')
                this.btnEle='<div class="filter_btn"><div class="delete"><i class="ic-ln tool_trash-f"></i><span>清空選項<span></div><a href="javascript:;" class="clp_btn "><span>' + this.option.btnSettings.closeHtml + '</span></a></div>'
            } else {
                console.log('other')
                this.btnEle = '<a href="javascript:;" class="clp_btn"><span>' + this.option.btnSettings.closeHtml + '</span></a>';

            }
            this.$ele.children('.high').after(this.btnEle);
        }

        // 選取.clp_btn.
        this.$clp_btn = this.$ele.find('.clp_btn');
        this.$clp_btntext = this.$ele.find('.clp_btn>span');

        // 有無輸入$maxH的處置
        if(this.$maxH){
            if(this.$ele.hasClass('open')){
                this.$ele.children('.high').css('max-height', 'inherit');
            }else{
                this.$ele.children('.high').css('max-height', this.$maxH);
            }
        }

        // 設定click & resize method.
        this.setClick();
        this.setResize();
        this.clickDelete();
        // 如果btnSettings.openHtml沒輸入時的處置.
        if(this.option.btnSettings.openHtml){
            // 如有設定btnSettings.openHtml時.
            this.opHtml = this.option.btnSettings.openHtml;
        }else{
            // 如沒設定btnSettings.openHtml時.
            if(this.option.open){
                // 如收合器預設為打開時,
                // html上的.clp_btn則視為open狀態,
                // 所以opHtml就給予.clp_btn的文字.
                this.opHtml = this.$clp_btntext.html();
            }else{
                // 如收合器預設為關閉時,
                // html上的.clp_btn則視為open狀態,
                // 所以opHtml就給予''.
                this.opHtml = '';
            }
        }

        // 如果btnSettings.closeHtml沒輸入時的處置.
        if(this.option.btnSettings.closeHtml){
            // 如有設定btnSettings.closeHtml時.
            this.clsHtml = this.option.btnSettings.closeHtml;
        }else{
            // 如沒設定btnSettings.openHtml時.
            if(this.option.open){
                // 如收合器預設為打開時, 
                // html上的.clp_btn則視為open狀態,
                // 所以clsHtml就給予''.
                this.clsHtml = '';
            }else{
                // 如收合器預設為關閉時.
                // html上的.clp_btn則視為close狀態,
                // 所以clsHtml就給予.clp_btn的文字.
                this.clsHtml = this.$clp_btntext.html();
            }
        }

        // 給按鈕預設文字.
        this.$clp_btntext.html(this.clsHtml);

        // 如收合器open參數設定為開, 則trigger按鈕click一次.
        if(this.option.open){
            this.$clp_btn.trigger('click');
        }

    };

    $.fn[ModuleName] = function(options) {

        return this.each(function() {
            var $this = $(this);
            // var module = $this.data( ModuleName );
            var opts = $.extend({}, Module.DEFAULT, (typeof options === 'object' && options));
            var module = new Module(this, opts);
            module.init();

        });
        
    };

})(jQuery);



// WEBPACK FOOTER //
// ./magaele/clp_gpby/module.js